import { render, staticRenderFns } from "./AdminChapter_questions_2.vue?vue&type=template&id=2196726c&"
import script from "./AdminChapter_questions_2.vue?vue&type=script&lang=js&"
export * from "./AdminChapter_questions_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports